/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

export const DRUG_MANUFACTURER_HEAD = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];

export const DRUG_FAMILY_HEAD = [
  {
    headerName: 'Select',
    filter: false,
    sortable: false,
    enableMenu: false,
    minWidth: 150,
    checkboxSelection: true, // For rows checkbox
    showCheckboxIcon: true,
    headerCheckboxSelection: true, // For header check box
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Drug Family ID',
    field: 'familySeqNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];
export const MANUFACTURER_HEAD = [
  {
    headerName: 'Select',
    filter: false,
    sortable: false,
    enableMenu: false,
    minWidth: 150,
    checkboxSelection: true, // For rows checkbox
    showCheckboxIcon: true,
    headerCheckboxSelection: true, // For header check box
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    cellRenderer: 'mfgNameRederer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];

export const TOP_GRID_TABLEHAD = [
  {
    headerName: 'Rebate Pricing Method',
    field: 'rebatePricingMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Volume Calc Method',
    field: 'volumeCalcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Market Share Calc Method',
    field: 'mktShareCalcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'National Mkt Share Type',
    field: 'natMktShareTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];

export const CALCULATED_URA_TABLEHAD = [
  {
    headerName: 'Comments',
    field: 'ccCommentexists',
    editable: false,
    sortable: false,
    minWidth: 100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefPaperIndCheckBoxRender',
    cellStyle: { 'border-right-color': '#D6D2D0' },
    showBackgroundColor: true,
  },
  {
    headerName: 'Calculated Quarter',
    field: 'calcQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Calculated URA',
    field: 'calcUra',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];

export const BOTTOM_GRID_TABLEHAD = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Target Quarter',
    field: 'targetQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Calculated Quarter',
    field: 'calcQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'In Effect Indicator',
    field: '',
    editable: false,
    sortable: false,
    minWidth: 100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefPaperIndCheckBoxRender',
    cellStyle: { 'border-right-color': '#D6D2D0' },
    showBackgroundColor: true,
  },
  {
    headerName: 'Calculated URA',
    field: 'calcUra',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Cal Method Cd',
    field: 'calcMethodCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': '#D6D2D0' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];
